(function(){
  'use strict';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* announcement rotator (legacy multi-message support) */
  var msgs = document.querySelectorAll('.announce-msg');
  var announceEl = document.querySelector('.announce, .fyos-announce');
  var announcePaused = false;
  var mi = 0;
  if (announceEl) {
    announceEl.addEventListener('mouseenter', function(){ announcePaused = true; });
    announceEl.addEventListener('mouseleave', function(){ announcePaused = false; });
  }
  if (msgs.length > 1 && !reduceMotion) {
    setInterval(function(){
      if (announcePaused) return;
      msgs[mi].classList.remove('is-active');
      mi = (mi + 1) % msgs.length;
      msgs[mi].classList.add('is-active');
    }, 4500);
  }

  /* sticky header: only toggle scrolled state; sticky positioning is CSS-driven via .is-sticky */
  var header = document.getElementById('fyosHeader') || document.getElementById('header');
  var announce = document.querySelector('.fyos-scope .fyos-announce');
  var isSticky = header && header.classList.contains('is-sticky');

  /* Sticky behaviour: the announcement bar scrolls away normally; the header/menu
     pins to the top only once you've scrolled past the announcement. On the homepage
     the transparent header floats over the hero (absolute), so there's no gap. */
  function applyFixedOffset(){
    if (!header) return;
    var headerH = header.offsetHeight || 72;
    var announceH = announce ? announce.offsetHeight : 0;
    var isHome = header.getAttribute('data-style') === 'transparent';
    var isMobile = window.matchMedia('(max-width:900px)').matches;
    var isPinned = header.classList.contains('is-pinned');

    // On DESKTOP home the header overlays the hero (absolute, below the announce bar).
    // On MOBILE the header is a solid bar in normal flow — no overlay, so clear any top.
    if (isHome && !isMobile && !isPinned) {
      header.style.top = announceH + 'px';
    } else {
      header.style.top = '';
    }

    // Content offset — only needed when the header is REMOVED from normal flow:
    //  • desktop home: absolute overlay → hero sits under it, NO push.
    //  • mobile: header is relative (in flow) and already takes space → NO push
    //    (pushing again would create a double gap). Only push once it's pinned (fixed).
    //  • non-home desktop: sticky header is relative until pinned → push only when pinned.
    var firstSection = document.querySelector('#content_wrapper .global-wrapper > .shopify-section, #content_wrapper .global-wrapper > *');
    var push = false;
    if (isHome && !isMobile) {
      push = false;                       // desktop overlay
    } else {
      push = isSticky && isPinned;        // mobile + other pages: only when pinned/fixed
    }
    if (firstSection) firstSection.style.paddingTop = push ? headerH + 'px' : '';
  }

  if (header) {
    var announceH = announce ? announce.offsetHeight : 0;
    var wasPinned = false;
    var onScroll = function(){
      var y = window.scrollY;
      var past = y > 40;
      header.classList.toggle('is-scrolled', past);
      header.classList.toggle('is-solid', past);
      // pin the menu to the very top once the announcement has scrolled out of view
      if (isSticky) {
        var aH = announce ? announce.offsetHeight : announceH;
        var pin = y >= aH;
        header.classList.toggle('is-pinned', pin);
        // when the pin state flips, recompute the content offset so nothing jumps
        if (pin !== wasPinned) { applyFixedOffset(); wasPinned = pin; }
      }
    };
    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', applyFixedOffset, {passive:true});
    applyFixedOffset();
    onScroll();
    // re-apply after fonts/images settle
    window.addEventListener('load', applyFixedOffset);
    setTimeout(applyFixedOffset, 300);
  }

  /* mobile drawer (FYOS nav) */
  var drawer = document.getElementById('fyosDrawer');
  var burger = document.getElementById('fyosBurger');
  function openDrawer(){ if(drawer){ drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); if(burger) burger.setAttribute('aria-expanded','true'); document.body.style.overflow='hidden'; } }
  function closeDrawer(){ if(drawer){ drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); if(burger) burger.setAttribute('aria-expanded','false'); document.body.style.overflow=''; } }
  if (burger) burger.addEventListener('click', openDrawer);
  document.querySelectorAll('[data-close-drawer]').forEach(function(el){ el.addEventListener('click', closeDrawer); });

  // mobile drawer: expandable subcategories
  document.querySelectorAll('.fyos-drawer-toggle').forEach(function(btn){
    btn.addEventListener('click', function(){
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeDrawer(); });

  /* ═══ CUSTOM CART DRAWER (FYOS) ═══ */
  var cartDrawer = document.getElementById('fyosCartDrawer');
  var cartBtn = document.getElementById('fyosCartBtn');
  // German store → always show € with German number format (1.234,56 €),
  // matching the storefront product prices regardless of the base-currency money_format.
  function fmtMoney(cents){
    if (typeof cents !== 'number') cents = parseInt(cents, 10) || 0;
    var euros = (cents / 100).toFixed(2);           // "1234.56"
    var parts = euros.split('.');                    // ["1234","56"]
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'); // "1.234"
    return intPart + ',' + parts[1] + '\u00A0\u20AC';  // "1.234,56 €"
  }

  function openCart(){ if(cartDrawer){ cartDrawer.classList.add('is-open'); cartDrawer.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; renderCart(); } }
  function closeCart(){ if(cartDrawer){ cartDrawer.classList.remove('is-open'); cartDrawer.setAttribute('aria-hidden','true'); document.body.style.overflow=''; } }

  function renderCart(){
    if (!cartDrawer) return;
    var body = document.getElementById('fyosCartBody');
    fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var itemsEl = document.getElementById('fyosCartItems');
        var emptyEl = document.getElementById('fyosCartEmpty');
        var footEl  = document.getElementById('fyosCartFoot');
        var countEl = document.getElementById('fyosCartCount');
        if (countEl) countEl.textContent = cart.item_count;

        if (!cart.items || cart.items.length === 0){
          if (emptyEl) emptyEl.style.display = 'block';
          if (itemsEl) itemsEl.innerHTML = '';
          if (footEl) footEl.hidden = true;
          var shipEl0 = document.getElementById('fyosCartShip'); if (shipEl0) shipEl0.hidden = true;
          return;
        }
        if (emptyEl) emptyEl.style.display = 'none';
        if (footEl) footEl.hidden = false;

        var html = '';
        cart.items.forEach(function(item){
          var img = item.image ? item.image.replace(/(\.[^.\/]+)(\?.*)?$/, '_120x$1$2') : '';
          var variant = (item.variant_title && item.variant_title !== 'Default Title') ? '<p class="fyos-cart-item-variant">'+item.variant_title+'</p>' : '';
          html += '<li class="fyos-cart-item" data-key="'+item.key+'">'
                + (img ? '<img src="'+img+'" alt="'+(item.product_title||'')+'">' : '<span></span>')
                + '<div class="fyos-cart-item-info">'
                +   '<p class="fyos-cart-item-title">'+item.product_title+'</p>'
                +   variant
                +   '<div class="fyos-cart-qty" data-key="'+item.key+'">'
                +     '<button type="button" data-qty-minus aria-label="Weniger">−</button>'
                +     '<span>'+item.quantity+'</span>'
                +     '<button type="button" data-qty-plus aria-label="Mehr">+</button>'
                +   '</div>'
                + '</div>'
                + '<div class="fyos-cart-item-right">'
                +   '<span class="fyos-cart-item-price">'+fmtMoney(item.final_line_price)+'</span>'
                +   '<button type="button" class="fyos-cart-item-remove" data-qty-remove>Entfernen</button>'
                + '</div>'
                + '</li>';
        });
        if (itemsEl) itemsEl.innerHTML = html;

        var subEl = document.getElementById('fyosCartSubtotal');
        if (subEl) subEl.textContent = fmtMoney(cart.total_price);

        // free-shipping progress
        var shipEl = document.getElementById('fyosCartShip');
        var threshold = parseInt(cartDrawer.getAttribute('data-free-ship-threshold') || '0', 10);
        if (shipEl && threshold > 0){
          shipEl.hidden = false;
          var msg = shipEl.querySelector('.fyos-cart-ship-msg');
          var bar = shipEl.querySelector('.fyos-cart-ship-bar span');
          var remaining = threshold - cart.total_price;
          if (remaining > 0){
            if (msg) msg.textContent = 'Noch ' + fmtMoney(remaining) + ' bis zum kostenlosen Versand';
            if (bar) bar.style.width = Math.min(100, (cart.total_price/threshold)*100) + '%';
          } else {
            if (msg) msg.textContent = '🎉 Du erhältst kostenlosen Versand!';
            if (bar) bar.style.width = '100%';
          }
        }

        // cart recommendations
        renderCartRecs(cart);
      })
      .catch(function(){ /* silent */ });
  }

  function renderCartRecs(cart){
    var recsEl = document.getElementById('fyosCartRecs');
    var track = document.getElementById('fyosCartRecsTrack');
    if (!recsEl || !track) return;
    function shortTitle(t){
      var words = String(t || '').trim().split(/\s+/);
      return words.length > 2 ? words.slice(0, 2).join(' ') + '…' : String(t || '');
    }
    if (!cart.items || cart.items.length === 0){ recsEl.hidden = true; return; }
    var pid = cart.items[0].product_id;
    var limit = recsEl.getAttribute('data-limit') || 4;
    var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
    // ids already in cart (avoid recommending them)
    var inCart = {};
    cart.items.forEach(function(it){ inCart[it.product_id] = true; });
    fetch(root + 'recommendations/products.json?product_id=' + pid + '&limit=' + limit + '&intent=related')
      .then(function(r){ return r.json(); })
      .then(function(data){
        if (!data.products || !data.products.length){ recsEl.hidden = true; return; }
        var html = '';
        data.products.forEach(function(p){
          if (inCart[p.id]) return;
          var img = (p.featured_image ? p.featured_image : (p.images && p.images[0]) || '');
          var vid = (p.variants && p.variants[0] ? p.variants[0].id : null);
          if (!vid) return;
          html += '<div class="fyos-cart-rec">'
                +   (img ? '<img src="'+img+'" alt="'+(p.title||'').replace(/"/g,'&quot;')+'">' : '<span></span>')
                +   '<div class="fyos-cart-rec-info">'
                +     '<a class="fyos-cart-rec-title" href="'+p.url+'" title="'+(p.title||'').replace(/"/g,'&quot;')+'">'+shortTitle(p.title)+'</a>'
                +     '<span class="fyos-cart-rec-price">'+fmtMoney(p.price)+'</span>'
                +   '</div>'
                +   '<button type="button" class="fyos-cart-rec-add" data-rec-add data-vid="'+vid+'" aria-label="Hinzufügen">+ Hinzufügen</button>'
                + '</div>';
        });
        if (!html){ recsEl.hidden = true; return; }
        track.innerHTML = html;
        recsEl.hidden = false;
        track.querySelectorAll('[data-rec-add]').forEach(function(btn){
          btn.addEventListener('click', function(){
            var vid = btn.getAttribute('data-vid');
            btn.disabled = true;
            fetch(root + 'cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ items:[{ id: Number(vid), quantity: 1 }] }) })
              .then(function(r){ return r.json(); })
              .then(function(){ renderCart(); if (typeof refreshCartCount === 'function') refreshCartCount(); })
              .catch(function(){ btn.disabled = false; });
          });
        });
        // arrow scroll
        recsEl.querySelectorAll('[data-cart-recs-dir]').forEach(function(btn){
          if (btn.dataset.bound) return;
          btn.dataset.bound = '1';
          btn.addEventListener('click', function(){
            var dir = parseInt(btn.getAttribute('data-cart-recs-dir'), 10);
            var card = track.querySelector('.fyos-cart-rec');
            var step = card ? card.getBoundingClientRect().width + 10 : 300;
            track.scrollBy({ left: dir * step, behavior: 'smooth' });
          });
        });
      })
      .catch(function(){ recsEl.hidden = true; });
  }

  function changeQty(key, qty){
    var body = document.getElementById('fyosCartBody');
    if (body) body.classList.add('fyos-cart-loading');
    fetch('/cart/change.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ id:key, quantity:qty })
    }).then(function(r){ return r.json(); })
      .then(function(){ if(body) body.classList.remove('fyos-cart-loading'); renderCart(); })
      .catch(function(){ if(body) body.classList.remove('fyos-cart-loading'); });
  }

  if (cartBtn && cartDrawer) {
    cartBtn.addEventListener('click', function(e){ e.preventDefault(); openCart(); });
  }
  if (cartDrawer){
    cartDrawer.querySelectorAll('[data-cart-close]').forEach(function(el){ el.addEventListener('click', closeCart); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeCart(); });
    // event delegation for qty +/- and remove
    cartDrawer.addEventListener('click', function(e){
      var row = e.target.closest('.fyos-cart-item'); if(!row) return;
      var key = row.getAttribute('data-key');
      var qtySpan = row.querySelector('.fyos-cart-qty span');
      var cur = qtySpan ? parseInt(qtySpan.textContent,10) : 1;
      if (e.target.closest('[data-qty-plus]')) changeQty(key, cur+1);
      else if (e.target.closest('[data-qty-minus]')) changeQty(key, Math.max(0, cur-1));
      else if (e.target.closest('[data-qty-remove]')) changeQty(key, 0);
    });
  }

  /* When something is added to cart anywhere, refresh + open drawer */
  document.addEventListener('fyos:cart-updated', function(){ renderCart(); openCart(); });
  // initial count sync
  renderCart();

  /* SEARCH: open the theme's native search overlay (#search via #search-toggle) */
  document.querySelectorAll('.fyos-search-trigger').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      var toggle = document.getElementById('search-toggle');
      if (toggle) { toggle.click(); return; }
      if (window.jQuery && window.jQuery('#search-toggle').length){ window.jQuery('#search-toggle').trigger('click'); return; }
      window.location.href = '/search';
    });
  });

  /* ticker duplication for seamless loop (null-safe) */
  var track = document.getElementById('tickerTrack');
  if (track) {
    track.innerHTML += '<div aria-hidden="true" style="display:contents">' + track.innerHTML + '</div>';
  }

  /* toast (null-safe, supports new + legacy id) */
  var toast = document.getElementById('fyosToast') || document.getElementById('toast');
  var toastTimer;
  function showToast(text){
    if (!toast) return;
    toast.textContent = text;
    toast.classList.add('is-visible','show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ toast.classList.remove('is-visible','show'); }, 2600);
  }

  /* demo-link toasts */
  document.querySelectorAll('[data-toast]').forEach(function(el){
    el.addEventListener('click', function(e){
      if (el.tagName === 'A' && el.getAttribute('href') === '#') e.preventDefault();
      showToast(el.getAttribute('data-toast'));
    });
  });

  /* catch-all for placeholder links without toast */
  document.querySelectorAll('a[href="#"]:not([data-toast])').forEach(function(a){
    a.addEventListener('click', function(e){
      e.preventDefault();
      showToast('Platzhalter – im finalen Shop verlinkt.');
    });
  });

  /* cart quick-add (Shopify AJAX when a variant id is present, demo toast otherwise) */
  var cartCount = document.getElementById('fyosCartCount') || document.getElementById('cartCount');
  var cartBtn = document.getElementById('fyosCartBtn') || document.getElementById('cartBtn');
  function refreshCartCount(){
    fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(c){
        if (cartCount) cartCount.textContent = c.item_count;
        if (cartBtn) cartBtn.setAttribute('aria-label', 'Warenkorb, ' + c.item_count + ' Artikel');
      }).catch(function(){});
  }
  document.querySelectorAll('[data-add]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var name = btn.getAttribute('data-add');
      var vid = btn.getAttribute('data-variant-id');
      if (vid) {
        fetch('/cart/add.js', {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
        }).then(function(r){ return r.json(); })
          .then(function(res){
            refreshCartCount();
            document.dispatchEvent(new CustomEvent('fyos:cart-updated', { bubbles: true, detail: res }));
          })
          .catch(function(){ showToast('Warenkorb aktuell nicht verfügbar.'); });
      } else {
        showToast('✓ „' + name + '“ wurde zum Warenkorb hinzugefügt.');
      }
    });
  });

  /* row scrollers */
  document.querySelectorAll('[data-scroll]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var row = document.querySelector(btn.getAttribute('data-scroll'));
      var card = row.firstElementChild;
      var step = card ? card.getBoundingClientRect().width + 16 : 320;
      row.scrollBy({left: step * Number(btn.getAttribute('data-dir')), behavior: reduceMotion ? 'auto' : 'smooth'});
    });
  });

  /* video cards: click to play/pause (muted autounmute-free) */
  document.querySelectorAll('.vid-card').forEach(function(card){
    var video = card.querySelector('video');
    var baseLabel = card.getAttribute('aria-label') || '';
    function toggle(){
      if (video.paused) {
        document.querySelectorAll('.vid-card video').forEach(function(v){ if (v !== video) { v.pause(); v.closest('.vid-card').classList.remove('is-playing'); } });
        video.muted = false;
        video.play();
        card.classList.add('is-playing');
        card.setAttribute('aria-label', baseLabel.replace('abspielen', 'pausieren'));
      } else {
        video.pause();
        card.classList.remove('is-playing');
        card.setAttribute('aria-label', baseLabel);
      }
    }
    card.addEventListener('click', toggle);
    card.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
  });

  /* spotlight variant switcher */
  var spotImg = document.getElementById('spotImg');
  var spotPrice = document.getElementById('spotPrice');
  var spotName = document.getElementById('spotVariantName');
  var spotAdd = document.getElementById('spotAdd');
  if (spotImg && spotAdd) {
    var spotPrefix = (spotAdd.getAttribute('data-add') || '').split(' ')[0] || '';
    document.querySelectorAll('.spot-thumb').forEach(function(btn){
      btn.addEventListener('click', function(){
        document.querySelectorAll('.spot-thumb').forEach(function(b){
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        spotImg.classList.add('is-fading');
        setTimeout(function(){
          spotImg.src = btn.getAttribute('data-img');
          spotImg.alt = (spotPrefix + ' ' + btn.getAttribute('data-variant')).trim();
          spotImg.classList.remove('is-fading');
        }, 200);
        if (spotName) spotName.textContent = btn.getAttribute('data-variant');
        if (spotPrice) spotPrice.textContent = btn.getAttribute('data-price');
        spotAdd.setAttribute('data-add', (spotPrefix + ' ' + btn.getAttribute('data-variant')).trim());
      });
    });
  }

  /* prewarm spotlight variant images */
  document.querySelectorAll('.spot-thumb').forEach(function(b){ var im = new Image(); im.src = b.getAttribute('data-img'); });

  /* newsletter — let Shopify's customer form submit natively; just confirm */
  var newsForm = document.getElementById('newsForm');
  if (newsForm) {
    newsForm.addEventListener('submit', function(){
      showToast('✓ Fast geschafft – bitte bestätige die E-Mail (Double-Opt-in).');
    });
  }

  /* reveal choreography */
  if (!reduceMotion && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, {rootMargin: '0px 0px -60px 0px', threshold: 0.1});
    document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
  }
  /* footer menu columns — accordion toggle (mobile only) */
  document.querySelectorAll('.fyos-foot-toggle').forEach(function(btn){
    btn.addEventListener('click', function(){
      // only act as accordion on mobile widths
      if (window.matchMedia('(max-width: 749px)').matches) {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      }
    });
  });
})();